module.exports = __webpack_public_path__ + "img/12.67c3c1f3.jpg";